export const handleChangeDataShopsPage = (name, value) => ({
    type: 'CHANGE_DATA_PAGE_SHOPS', name, value
});